<template>
  <!-- begin #footer -->
  <div id="footer" class="text-center p-4">
    &copy; {{ new Date().getFullYear() }} JKT Gateway. All Rights Reserved
  </div>
  <!-- end #footer -->
</template>

<script>
import PageOptions from "../../config/PageOptions.vue";

export default {
  name: "Footer",
  data() {
    return {
      pageOptions: PageOptions,
    };
  },
};
</script>
